export async function generateRequestHash(apiUrl: string): Promise<string | null> {
  try {
    const bek = window.SafeExamBrowser?.security?.browserExamKey;
    if (!bek) return null;

    const data = new TextEncoder().encode(apiUrl + bek);
    
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");

    return hashHex;
  } catch (error) {
    console.error("Lỗi tạo hash:", error);
    return null;
  }
}
